var map = {
	"./appetite.jpg": 718,
	"./christmas.jpg": 3487,
	"./dw_christmas.jpg": 2880,
	"./dw_navy.jpg": 237,
	"./greens.jpg": 3812,
	"./krill.jpg": 2015,
	"./par.jpg": 6887,
	"./par_1.jpg": 2266
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8273;